import classnames from 'classnames';
import { ContentUnderTopAppBar, TopAppBar } from '@llt-frontend/react-material-top-app-bar';
import FooterContent from '../components/footer-content';
import PropTypes from 'prop-types';
import React from 'react';

// Media
import logoSvg from '@llt-frontend/brands/varsity-tutors/e.svg';

// Internal
// --------

function Header(forwardedProps) {
  return (
    <TopAppBar {...forwardedProps} className="site-header">
      <a href="/">
        <img alt="Varsity Tutors" className="mdc-top-app-bar__site-logo" src={logoSvg} />
        Varsity Tutors
      </a>
    </TopAppBar>
  );
}

function Main({ children, isMobileApp }) {
  return (
    <ContentUnderTopAppBar
      className={classnames('main', { 'main--mobile': isMobileApp })}
      component="main"
      role="main"
    >
      {children}
    </ContentUnderTopAppBar>
  );
}

function MainContent({ children }) {
  return <div className="main-content">{children}</div>;
}

function Footer() {
  return (
    <footer className="site-footer">
      <FooterContent />
    </footer>
  );
}

//

function PrimaryLayout({ children, title, isMobileApp = false }) {
  return (
    <>
      {!isMobileApp && <Header title={title} />}

      <Main {...{ isMobileApp }}>
        <MainContent>{children}</MainContent>

        <Footer />
      </Main>
    </>
  );
}

PrimaryLayout.propTypes = {
  children: PropTypes.node.isRequired,
};

// External
// --------

export default PrimaryLayout;
